import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);
const SUPPORTED = ["en", "fr", "ar"];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem("maif_lang");
    return SUPPORTED.includes(stored) ? stored : "en";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("maif_lang", lang);
      document.documentElement.lang = lang;
      document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    }
  }, [lang]);

  const cycle = () => {
    const idx = SUPPORTED.indexOf(lang);
    setLang(SUPPORTED[(idx + 1) % SUPPORTED.length]);
  };

  const value = {
    lang,
    setLang,
    toggle: cycle,
    isRTL: lang === "ar",
    t: translations[lang] || translations.en,
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
